// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"22836836","118":"94230da4","142":"7d13550a","168":"8fec23c0","264":"1446a49a","377":"7f792529","511":"28a9656c"}[chunkId] + ".chunk.js";
};